import React from "react";
import { PlainButton } from "@jugl-web/ui-kit";
import { useKnowledgeTraining } from "@web-src/modules/cx/providers/KnowledgeTrainingProvider";
import { ReactComponent as ArrowIcon } from "./assets/arrow.svg";
import { ReactComponent as FileIcon } from "./assets/file.svg";
import { ReactComponent as TrashIcon } from "./assets/trash.svg";
import { AgentKnowledgeContentHeader } from "../../../AgentKnowledgeContentHeader";
import { BlockingOverlayLoader } from "../../../BlockingOverlayLoader/BlockingOverlayLoader";

export const FileKnowledgePreview: React.FC<{
  title: string;
  content: string;
  onDelete: () => void;
  onRequestClose: () => void;
}> = ({ title, content, onRequestClose, onDelete }) => {
  const { trainingStatus } = useKnowledgeTraining();

  return (
    <div className="flex h-full w-full flex-col bg-white">
      <AgentKnowledgeContentHeader
        icon={<FileIcon />}
        title={title}
        startContent={
          <PlainButton
            className="flex h-6 w-10 shrink-0 items-center justify-center"
            onClick={onRequestClose}
            disabled={trainingStatus === "in_process"}
          >
            <ArrowIcon />
          </PlainButton>
        }
        endContent={
          <PlainButton
            className="flex h-6 w-10 shrink-0 items-center justify-center"
            onClick={onDelete}
            disabled={trainingStatus === "in_process"}
          >
            <TrashIcon />
          </PlainButton>
        }
      />
      <div className="relative h-full min-h-0">
        <BlockingOverlayLoader />
        <div className="jugl__custom-scrollbar h-full overflow-y-auto px-10 py-8">
          {content}
        </div>
      </div>
    </div>
  );
};
